var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"vueWaterfall",staticClass:"vue-waterfall",class:_vm.isTransition&&'is-transition',style:({height:_vm.height}),attrs:{"id":"vueWaterfall"}},[_c('div',{ref:"waterfallWrapper",staticClass:"waterfall-wrapper"}),_c('div',{staticClass:"slot-box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }